import React from 'react';
import { useNavigate } from 'react-router-dom';
import { courses } from '../data/courses';
import './Dashboard.css';

const CourseCard = ({ course, onClick }) => (
  <div className="course-card" onClick={onClick}>
    <div className="course-image">
      <img src={course.image} alt={course.title} />
    </div>
    <div className="course-info">
      <h3>{course.title}</h3>
      <p className="course-description">{course.description}</p>
      <div className="course-meta">
        <span className="duration">{course.duration}</span>
        <span className="level">{course.level}</span>
      </div>
      <div className="course-progress">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${course.progress}%` }}
          ></div>
        </div>
        <span className="progress-text">{course.progress}% Complete</span>
      </div>
    </div>
  </div>
);

const Dashboard = () => {
  const navigate = useNavigate();

  const handleCourseClick = (courseId) => {
    navigate(`/course/${courseId}`);
  };

  return (
    <div className="dashboard">      
      <section className="dashboard-content">
        <div className="courses-section">
          <h2>Available Courses</h2>
          <div className="courses-grid">
            {courses.map((course) => (
              <CourseCard
                key={course.id}
                course={course}
                onClick={() => handleCourseClick(course.id)}
              />
            ))}
          </div>
        </div>

        <div className="dashboard-sidebar">
          <div className="progress-summary">
            <h3>Overall Progress</h3>
            <div className="progress-stats">
              <div className="stat-item">
                <span className="stat-value">
                  {courses.filter(course => course.progress === 100).length}
                </span>
                <span className="stat-label">Courses Completed</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">{courses.length}</span>
                <span className="stat-label">Courses Available</span>
              </div>
            </div>
          </div>

          <div className="recent-activity">
            <h3>Recent Activity</h3>
            <div className="activity-list">
              <p className="no-activity">No recent activity</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard; 